import type { ReactNode } from 'react';

/** Mantiene los formularios montados al plegar para conservar lo que se está editando. */
export function Desplegable({ titulo, resumen, children, abierta = false }: {
  titulo: string;
  resumen?: string;
  children: ReactNode;
  abierta?: boolean;
}) {
  return <details open={abierta || undefined} className="superficie-tarjeta group/seccion rounded-xl border border-(--color-borde) bg-(--color-panel)">
    <summary className="flex min-h-14 cursor-pointer list-none items-center justify-between gap-3 px-3 py-2 focus-visible:outline-2 focus-visible:outline-(--color-acento)">
      <span className="min-w-0">
        <span className="block font-semibold">{titulo}</span>
        {resumen && <span className="block text-xs text-(--color-apagado)">{resumen}</span>}
      </span>
      <span aria-hidden="true" className="text-(--color-acento) transition-transform group-open/seccion:rotate-90">▸</span>
    </summary>
    <div className="flex flex-col gap-3 border-t border-(--color-borde) p-3">{children}</div>
  </details>;
}
